import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Box,
} from "@mui/material";
import useUpdate from "../../api/useUpdate";
import { useTranslation } from "react-i18next";

const PurchaseReturnEdit = ({ open, onClose, editData, token }) => {
  const { t } = useTranslation();
  const { handleUpdate, loading, isSuccess } = useUpdate("shop/purchase-returns", token);

  const [reason, setReason] = useState("");

  useEffect(() => {
    if (editData) {
      setReason(editData.reason || "");
    }
  }, [editData]);

  const handleSubmit = () => {
    const formData = {
      reason: (reason || "").trim(),
    };
    handleUpdate(editData.id, formData);
  };

  useEffect(() => {
    if (isSuccess) {
      setReason("");
      onClose();
    }
  }, [isSuccess, onClose]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t("PurchaseReturnIndex.form_editTitle")}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate sx={{ mt: 1 }}>
          <TextField
            autoFocus
            margin="dense"
            label={t("PurchaseReturnIndex.form_reason")}
            type="text"
            fullWidth
            multiline
            rows={4}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={loading}>
          {t("common.cancel")}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={loading}
          sx={{ minWidth: 100 }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            t("common.update")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PurchaseReturnEdit;